module.exports = __webpack_public_path__ + "static/media/project_3d.81b3f454.jpg";